import { ExploreSearch } from 'src/features/common/explore/components/explore-search/explore-search';
import { Visible } from 'src/ui/common/layouts/visible';
import { media } from 'src/ui/common/mixins/media';
import { Select } from 'src/ui/white-labels/techcontemporary/organisms/select';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
    margin-bottom: 20px;

    ${media.sm`
    display: flex;
  `}
`;

export const DesktopActions = styled(Visible)`
    max-width: 340px;
    flex: 3;
    margin-left: 10px;

    input,
    svg {
        color: ${({ theme }) => theme.colors.gs200};
    }

    ${media.md`
        flex: 0 0 110px;
  `}
`;

export const MobileActions = styled(Visible)`
    margin-top: 5px;

    & button {
        flex: 1;
    }

    & button + button {
        margin-left: 5px;
    }
`;

export const StyledSearchInput = styled(ExploreSearch)`
    margin-bottom: 14px;

    & input {
        height: 50px !important;
    }

    & svg:nth-of-type(1) {
        top: 13px !important;
    }
`;

export const StyledSelect = styled(Select)`
    & input {
        padding: 10px 34px 10px 16px;
        border-radius: 74px;
        border: 1px solid rgba(255, 255, 255, 0.15);
    }

    & svg {
        right: 12px;
    }
`;